module.exports = __webpack_public_path__ + "assets/img/social/twitter-icon.90397f0bc6531191c5da032516ae17c0.svg";